export default "__VITE_ASSET__BbS_tpNt__"